import styles from "styles/containers/cart-item.module.scss";

import { Currency } from "shared/tools";
import { Store } from "@/shared/core/Store";

const NetLogicItem = ({ product }) => {
  const getSubItemsOverview = () => {
    return (
      <div className={styles.question}>
        <span>
          {product.condiments
            .map((subItem) => `${subItem.quantity}x ${subItem.name}`)
            .join(", ")}
        </span>
      </div>
    );
  };

  return (
    <div className={styles.item}>
      <div className={styles.details}>
        <div className="d-flex align-center w-100 justify-between">
          <div className="d-flex flex-column">
            <p className={styles.qty}>{product.quantity}x</p>
            <p className={styles.itemName}>{product?.name}</p>
          </div>
          <div className={styles.total}>
            <p className={styles.value}>
              {Currency.formatCurrency(product.unitPrice)}
            </p>
            {product.itemDiscounts?.[0] && (
              <p className={styles.discount}>
                Desconto de{" "}
                {Currency.formatCurrency(
                  product.quantity * product.itemDiscounts[0].total
                )}
              </p>
            )}
          </div>
        </div>

        {product.condiments.length > 0 && (
          <div className={styles.questions}>{getSubItemsOverview()}</div>
        )}
      </div>
    </div>
  );
};

export default function NetLogicCartItem({ order }) {
  const filteredItems = order.filter(
    (item) => {
      const callWaiterSku = Store.netlogic?.callWaiterSku
        ? Store.netlogic.callWaiterSku.substring(1)
        : null;

      const isCallWaiter = String(item.menuItemId) === callWaiterSku;
      return !isCallWaiter;
    }
  );

  return (
    <div className={styles.netLogicItems}>
      {(filteredItems || []).map((item, index) => (
        <NetLogicItem
          key={`cart-item-${Math.random()}`}
          product={item}
          cartItemIndex={index}
        />
      ))}
    </div>
  );
}
